import React, { useState } from "react";
import GView from "../Elements/GView";
import { ApiService } from "../services";
import GTabs from "../Elements/gTabs";
import useDataFctory from "../useDataFactory";
import { useSnackbar } from "notistack";
import GText from "../Elements/GText";
import ThumbUpAlt from "../assets/images/thumbs-up.svg";
import ThumbDownAlt from "../assets/images/thumbs-down.svg";

export default function Faqs() {
  const faqTypes = ["order", "offers", "account", "other"];
  const [typeValue, setTypeValue] = useState(faqTypes[0]);
  const { enqueueSnackbar } = useSnackbar();
  const { loading, Shimmer, Placeholder, data, refreshData } = useDataFctory(
    "faqs",
    false
  );

  const handleChangeTab = (newVal) => {
    console.log(newVal);
    setTypeValue(newVal);
  };
  const handleQuery = (value, id) => {
    let userData = JSON.parse(localStorage.getItem("settings"));
    if (!userData.user?.id) {
      enqueueSnackbar("Please login first to send feedback");
      return;
    }
    ApiService({
      method: "POST",
      route: "c/faq/feedback",
      body: { faq_id: id, liked: value },
    })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          refreshData();
        }
        enqueueSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div className="main-content">
      <GText g2="true" bold text={"Help & FAQ's"} />
      <GView
        style={{
          boxShadow: "0 0 10px #cccccc85",
          padding: "20px",
          margin: "20px 0",
        }}
      >
        <GTabs
          routes={faqTypes}
          active={typeValue}
          type="single"
          onClick={handleChangeTab}
        ></GTabs>

        <GView style={{ padding: "20px 0" }}>
          {loading === true ? (
            <Shimmer />
          ) : data.filter((r) => r.faq_type === typeValue).length === 0 ? (
            <Placeholder />
          ) : (
            data
              .filter((r) => r.faq_type === typeValue)
              .map((f, i) => {
                return (
                  <GView key={i} style={{ margin: "20px 0" }}>
                    <GText g4 text={f.question} style={{ margin: "10px 0" }} />
                    <GText
                      dark
                      text={f.answer}
                      style={{ letterSpacing: "0", fontSize: "15.5px" }}
                    />
                    <div style={{ textAlign: "right" }}>
                      <h5
                        style={{
                          margin: "10px 0",
                          fontWeight: "400",
                          color: "#a2a2a2",
                          fontSize: "15px",
                        }}
                      >
                        Was this answer helpful ?
                        <ul
                          style={{
                            display: "inline-flex",
                            color: "#ccc",
                            listStyleType: "none",
                            margin: "0 0 10px",
                            padding: "0 5px",
                          }}
                        >
                          <li
                            style={{ padding: "0 5px", cursor: "pointer" }}
                            onClick={() => handleQuery("1", f.id)}
                          >
                            <img
                              src={ThumbUpAlt}
                              style={{ width: "18px", verticalAlign: "bottom" }}
                            />
                          </li>
                          |
                          <li
                            style={{ padding: "0 5px", cursor: "pointer" }}
                            onClick={() => handleQuery("2", f.id)}
                          >
                            <img
                              src={ThumbDownAlt}
                              style={{ width: "18px", verticalAlign: "bottom" }}
                            />
                          </li>
                        </ul>
                      </h5>
                    </div>
                  </GView>
                );
              })
          )}
        </GView>
      </GView>
      <br />
    </div>
  );
}
